import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Plus } from 'lucide-react';
import CSVButton from '../Common/CSVButton';

interface IncentiveHeaderProps {
  title?: string;
  showBack?: boolean;
  onBackClick?: () => void;
  onCreateClick?: () => void;
  onExportCsv?: () => void;
  showActions?: boolean;
  createButtonText?: string;
}

export const IncentiveHeader: React.FC<IncentiveHeaderProps> = ({
  title = 'Distributor Incentives',
  showBack = true,
  onBackClick,
  onCreateClick,
  onExportCsv,
  showActions = true,
  createButtonText = 'Create Incentive',
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 mb-6 select-none">
      {/* Title & Back Arrow */}
      <div className="flex items-center gap-3">
        {showBack && (
          <button
            onClick={handleBack}
            className="w-8 h-8 rounded-full bg-[#C1272D] hover:bg-[#A81E23] transition-all flex items-center justify-center text-white cursor-pointer shadow-sm"
            title="Go Back"
          >
            <ArrowLeft className="w-4 h-4" />
          </button>
        )}
        <h1 className="text-2xl font-extrabold text-[#C1272D] tracking-tight">
          {title}
        </h1>
      </div>

      {/* Top Action Buttons */}
      {showActions && (
        <div className="flex items-center gap-3">
          {onCreateClick && (
            <button
              onClick={onCreateClick}
              className="bg-[#B71C1C] hover:bg-[#960101] text-white text-xs md:text-sm font-semibold px-4 py-2 rounded-xl flex items-center gap-1.5 shadow-sm transition-all hover:shadow cursor-pointer"
            >
              <Plus className="w-4 h-4" />
              <span>{createButtonText}</span>
            </button>
          )}

          {onExportCsv ? (
            <CSVButton onClick={onExportCsv} />
          ) : (
            <CSVButton onClick={() => alert('Exporting incentives to CSV...')} />
          )}
        </div>
      )}
    </div>
  );
};
